import { ActionType } from '../BorrowerConstants';
import store, { borrowerActions } from '@apply/adminStore';
import { LinkType } from '../BorrowerConstants';
import { BorrowerApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import { RefreshEvents } from '../../../common/SharedEvents';
import { NavigateFunction } from 'react-router-dom';

export const executeAction = (
    itemData: {
        actionId: number;
        principalId: number;
        entityId: number;
        companyId: number;
        linkType: LinkType;
    },
    navigate: NavigateFunction
) => {
    const { dispatch } = store;
    const borrowerApi = new BorrowerApi.BorrowerApi(applicationInsights);
    const refreshEvents = new RefreshEvents();

    const onEditCompany = (companyId: number) => {
        dispatch(
            borrowerActions.setEditCompanyModal({
                editCompanyModal: { isOpen: true, companyId },
            })
        );
    };

    const onEditEntity = (entityId: number, companyId: number) => {
        dispatch(
            borrowerActions.setEditEntityModal({
                editEntityModal: { isOpen: true, entityId, companyId },
            })
        );
    };

    const onEditPrincipal = (principalId: number, entityId = 0) => {
        dispatch(
            borrowerActions.setEditPrincipalModal({
                editPrincipalModal: { isOpen: true, principalId, entityId },
            })
        );
    };

    const onEditBorrowerEntityToPrincipalLink = (entityId: number, principalId: number, linkType: LinkType) => {
        dispatch(
            borrowerActions.setEditBorrowerEntityToPrincipalLinkModal({
                editBorrowerEntityToPrincipalLinkModal: {
                    isOpen: true,
                    entityId,
                    principalId,
                    linkType,
                },
            })
        );
    };

    const onDeleteBorrowerEntityToPrincipalLink = (entityId: number, principalId: number, linkType: LinkType) => {
        dispatch(
            borrowerActions.setDeleteBorrowerEntityToPrincipalLinkModal({
                deleteBorrowerEntityToPrincipalLinkModal: {
                    isOpen: true,
                    entityId,
                    principalId,
                    linkType,
                },
            })
        );
    };

    const onDeleteBorrowerBusinessToPrincipalLink = (companyId: number, principalId: number, linkType: LinkType) => {
        dispatch(
            borrowerActions.setDeleteBusinessToPrincipalLinkModal({
                deleteBusinessToPrincipalLinkModal: {
                    isOpen: true,
                    companyId,
                    principalId,
                    linkType,
                },
            })
        );
    };

    const onRecycleCompany = async (companyId: number) => {
        dispatch(
            borrowerActions.setRecycleBinModal({
                recycleBinModal: { isOpen: true, companyId },
            })
        );
    };

    const onRecycleEntity = async (entityId: number) => {
        dispatch(
            borrowerActions.setRecycleBinModal({
                recycleBinModal: { isOpen: true, entityId },
            })
        );
    };

    const onRecyclePrincipal = async (principalId: number) => {
        dispatch(
            borrowerActions.setRecycleBinModal({
                recycleBinModal: { isOpen: true, principalId },
            })
        );
    };

    const onRestoreCompany = async (companyId: number) => {
        await borrowerApi.recycleCompany(companyId, false);
        refreshEvents.dispatchRefreshEvent();
    };

    const onRestoreEntity = async (entityId: number) => {
        await borrowerApi.recycleEntity(entityId, false);
        refreshEvents.dispatchRefreshEvent();
    };

    const onRestorePrincipal = async (principalId: number) => {
        await borrowerApi.recyclePrincipal(principalId, false);
        refreshEvents.dispatchRefreshEvent();
    };

    const onDeleteCompany = async (companyId: number) => {
        dispatch(
            borrowerActions.setDeleteForeverModal({
                deleteForeverModal: { isOpen: true, companyId },
            })
        );
    };

    const onDeleteEntity = async (entityId: number) => {
        dispatch(
            borrowerActions.setDeleteForeverModal({
                deleteForeverModal: { isOpen: true, entityId },
            })
        );
    };

    const onDeletePrincipal = async (principalId: number) => {
        dispatch(
            borrowerActions.setDeleteForeverModal({
                deleteForeverModal: { isOpen: true, principalId },
            })
        );
    };

    const onPrincipalExperience = (principalId: number) => {
        navigate(`/experiences/principals/${principalId}`);
    };

    const onEntityAuditHistory = async (entityId: number) => {
        dispatch(
            borrowerActions.setEntityAuditHistoryModal({
                entityAuditHistoryModal: { isOpen: true, entityId },
            })
        );
    };

    const onNotImplemented = () => {
        alert('Not Implemented yet!');
    };

    switch (itemData.actionId) {
        case ActionType.EditCompany:
            onEditCompany(itemData.companyId);
            break;
        case ActionType.EditPrincipal:
            onEditPrincipal(itemData.principalId, itemData.entityId);
            break;
        case ActionType.EditEntity:
            onEditEntity(itemData.entityId, itemData.companyId);
            break;
        case ActionType.EditBorrowerEntityToPrincipalLink:
            onEditBorrowerEntityToPrincipalLink(itemData.entityId, itemData.principalId, itemData.linkType);
            break;
        case ActionType.DeleteBorrowerEntityToPrincipalLink:
            onDeleteBorrowerEntityToPrincipalLink(itemData.entityId, itemData.principalId, itemData.linkType);
            break;
        case ActionType.DeleteBusinessToPrincipalLink:
            onDeleteBorrowerBusinessToPrincipalLink(itemData.companyId, itemData.principalId, itemData.linkType);
            break;
        case ActionType.RemoveCompany:
            onRecycleCompany(itemData.companyId);
            break;
        case ActionType.RestoreCompany:
            onRestoreCompany(itemData.companyId);
            break;
        case ActionType.RemoveEntity:
            onRecycleEntity(itemData.entityId);
            break;
        case ActionType.RestoreEntity:
            onRestoreEntity(itemData.entityId);
            break;
        case ActionType.RemovePrincipal:
            onRecyclePrincipal(itemData.principalId);
            break;
        case ActionType.RestorePrincipal:
            onRestorePrincipal(itemData.principalId);
            break;
        case ActionType.DeleteCompany:
            onDeleteCompany(itemData.companyId);
            break;
        case ActionType.DeleteEntity:
            onDeleteEntity(itemData.entityId);
            break;
        case ActionType.DeletePrincipal:
            onDeletePrincipal(itemData.principalId);
            break;
        case ActionType.PrincipalExperience:
            onPrincipalExperience(itemData.principalId);
            break;
        case ActionType.EntityAuditHistory:
            onEntityAuditHistory(itemData.entityId);
            break;
        default:
            onNotImplemented();
            break;
    }
};
